import { render } from "./RemoveMenuModifierItem.vue?vue&type=template&id=3b9c638c&scoped=true"
import script from "./RemoveMenuModifierItem.vue?vue&type=script&lang=js"
export * from "./RemoveMenuModifierItem.vue?vue&type=script&lang=js"

import "./RemoveMenuModifierItem.vue?vue&type=style&index=0&id=3b9c638c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9c638c"]])

export default __exports__